import { log } from "../../../";

import * as React from "react";
import { observer } from "mobx-react";

import * as CustomLists from "models/customLists";
import { CreateListsStore } from "stores/CreateListsStore";
import { CategoryImageCard } from "./CategoryImageCard";
import { CategoryMenuFolderCard } from "../CategoryMenuFolderCard";
import DraggableFolderItem from "../DraggableFolderItem";
import DragDropFolder from "../DragDropFolder";
import { CategoryItem } from "models";
import CategoryImage from "models/customLists/CategoryImage";
import { Grid, IconButton, Paper, Typography } from "@material-ui/core";
import { strings } from "core/localizedStrings";
import * as Icons from "core/utils/Icons";

var ReactList = require("react-list");

export interface FetchListProps extends React.Props<any> {
    store: CreateListsStore;
    selectedItems: Array<CategoryItem>;
    editImageCardTitleCallback: (image: CategoryImage) => void;
    editFolderCardTitleCallback: (folder: CustomLists.Folder) => void;
}

@observer
export class FetchList extends React.Component<FetchListProps> {
    public render() {
        let totalCount = this.props.store.visibleItems.length + 1;
        return (
            <ReactList
                key={this.props.store.visibleFolder ? this.props.store.visibleFolder.key : ""}
                type="simple"
                itemRenderer={this.renderItem}
                length={totalCount}
                pageSize={20}
            />
        );
    }

    private itemDroppedOnFolder = (source: any, target: any) => {
        let targetFolder = target.props.folder;
        if (source.type === CategoryMenuFolderCard) {
            let sourceFolder = source.props.folder;
            this.props.store.moveFolderToFolder(sourceFolder, targetFolder, this.props.store.currentTab);
        } else if (source.type === CategoryImageCard) {
            let sourceItem = source.props.image;
            this.props.store.moveItemToFolder(sourceItem, targetFolder, this.props.store.currentTab);
        }
    };

    private renderItem = (index: number, key: string) => {
        if (this.props.store.visibleItems.length > 1 && this.props.store.visibleItems.length === index) {
            return null;
        }
        if (this.props.store.visibleItems === undefined || this.props.store.visibleItems.length === 0) {
            if (this.props.store.currentTab === CustomLists.TabSelection.MY_IMAGES && !this.props.store.isSearching) {
                return (
                    <Paper style={{ marginTop: 30, padding: 20, width: "100%" }} square={true}>
                        <Grid container justify="center" alignItems="center" direction="column">
                            <Grid item>
                                <Typography variant="h6">{strings.noImagesGetStarted}</Typography>
                            </Grid>
                            <Grid item>
                                <IconButton
                                    onClick={() => {
                                        this.props.store.setShouldShowImagesUploader(true);
                                    }}
                                >
                                    <Icons.Upload style={{ width: 50, height: 50 }} />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </Paper>
                );
            }
            return null;
        }

        let totalItems = this.props.store.visibleItems.length;
        let singleItemLoaded = totalItems === 1 && index === 1;
        if (totalItems > index || singleItemLoaded) {
            let item = this.props.store.visibleItems[index];
            if (item instanceof CustomLists.Folder) {
                return (
                    <DragDropFolder
                        key={item.key}
                        onDroppedOnTarget={this.itemDroppedOnFolder}
                        childObject={
                            <CategoryMenuFolderCard
                                onBackgroundClickedCallback={this.props.store.folderSelected.bind(this.props.store)}
                                folder={item as CustomLists.Folder}
                                store={this.props.store}
                            />
                        }
                    />
                );
            } else if (item instanceof CategoryImage) {
                let image = this.props.selectedItems.find((categoryItem: CategoryItem) => {
                    return categoryItem.imageKey === item.key;
                });
                let isSelected = image === undefined ? false : true;
                return (
                    <DraggableFolderItem
                        key={item.key}
                        onItemDropped={this.itemDroppedOnFolder}
                        childObject={
                            <div style={{ paddingTop: 5 }}>
                                <CategoryImageCard
                                    isSelected={isSelected}
                                    key={key}
                                    image={item as CategoryImage}
                                    store={this.props.store}
                                />
                            </div>
                        }
                    />
                );
            } else {
                log.verbose("Unknown list item type");
                return null;
            }
        }

        return null;
    };
}
